import React from 'react';
import { Row, COLORS } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';

export const ActiveStatus = styled(Row)`
  border: 1px solid ${COLORS.COLA};
  border-radius: 2px;
  padding: 0 4px;
  width: 72px;
`;

const CapitalizedText = styled(Text)`
  text-transform: uppercase;
`;

const STATUS_MAP = {
  ADDED: 'ADDED',
  DEMO: 'DEMO',
  TRL: 'TRIAL',
  PAID: 'PAID',
  ACT: 'ACTIVE',
  INACT: 'INACTIVE',
  LEFT: 'LEFT',
  PSD: 'PAUSED',
  HOLD: 'HOLD',
};

export default function ActiveStatusIndicator({ status }) {
  return (
    <ActiveStatus alignItems="center" justifyContent="center">
      <CapitalizedText variant="body3">{STATUS_MAP[status] || status}</CapitalizedText>
    </ActiveStatus>
  );
}
